import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  body {\n    background: none transparent;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ResizeObserver } from "@juggle/resize-observer";
import * as LocalStorage from "@purple-dot/browser-sdk/src/libraries/local-storage";
import * as SessionStorage from "@purple-dot/browser-sdk/src/libraries/session-storage";
import useEventListener from "@use-it/event-listener";
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { createGlobalStyle } from "styled-components";
import { AlertIcon } from "../../components/EmbeddedApp/CartButton/AlertIcon";
import { Button } from "../../components/EmbeddedApp/CartButton/Button";
import { ClockIcon } from "../../components/EmbeddedApp/CartButton/ClockIcon";
import * as CheckoutApi from "../../components/EmbeddedApp/checkout-api";
import IframePage from "../../components/EmbeddedApp/PageTypes/IframePage";
import expressPage from "../../webserver-page";
function CartButtonIframe(param) {
    var secureSessionToken = param.secureSessionToken, showButton = param.showButton, checkoutId = param.checkoutId, instanceId = param.instanceId, initialStyle = param.style;
    var ref = useState(initialStyle), style = ref[0], setStyling = ref[1];
    var parentPage = CartParentPage({
        instanceId: instanceId
    });
    useEffect(function() {
        parentPage.loaded(showButton);
        var elem = document.body;
        var resizeObserver = new ResizeObserver(function() {
            parentPage.sizeChanged(elem.offsetWidth, elem.offsetHeight);
        });
        resizeObserver.observe(elem);
    }, []);
    useEventListener("message", function(event) {
        var message = event.data;
        if ((message === null || message === void 0 ? void 0 : message.type) && (message === null || message === void 0 ? void 0 : message.data)) {
            var type = message.type, data = message.data;
            if (type === "UPDATE") {
                setStyling(_object_spread_props(_object_spread({}, style), {
                    fill: data.fill
                }));
            }
        }
    });
    useEventListener("storage", function() {
        var checkoutSession = SessionStorage.getItem("checkoutSession");
        var show = checkoutSession && checkoutSession.lineItems.length > 0;
        parentPage.postVisibilityChanged({
            show: show
        });
    });
    useSecureTokenEffect({
        secureSessionToken: secureSessionToken
    });
    useFetchCheckoutEffect({
        checkoutId: checkoutId
    });
    return /*#__PURE__*/ _jsxs(IframePage, {
        head: {},
        useFullstory: false,
        children: [
            /*#__PURE__*/ _jsx(NoBodyBackground, {
                globalCSS: "html,body { height: ".concat(style.height, "; width: ").concat(style.width, "; }")
            }),
            /*#__PURE__*/ _jsxs(Button, {
                styling: style,
                onMouseEnter: function() {
                    // Check if we have a mouse and dont fire if we dont
                    if (!window.matchMedia("(pointer:fine)").matches) {
                        return;
                    }
                    parentPage.cartButtonEntered();
                },
                onClick: function() {
                    parentPage.cartButtonClicked();
                },
                children: [
                    /*#__PURE__*/ _jsx(ClockIcon, {}),
                    /*#__PURE__*/ _jsx(AlertIcon, {
                        "data-testid": "alert-icon",
                        styling: style
                    })
                ]
            })
        ]
    });
}
var NoBodyBackground = createGlobalStyle(_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
function useSecureTokenEffect(param) {
    var secureSessionToken = param.secureSessionToken;
    if (secureSessionToken) {
        LocalStorage.setItem("_pd_secure_session_token", secureSessionToken);
    }
}
/*
  Fetch and save the checkout session as soon as possible
  so the other components can use it
*/ function useFetchCheckoutEffect(param) {
    var checkoutId = param.checkoutId;
    var FetchCheckoutTask = useAsync({
        deferFn: CheckoutApi.fetchCheckout,
        onResolve: function(data) {
            SessionStorage.setItem("checkoutSession", data);
        },
        onReject: function(err) {
            // biome-ignore lint/suspicious/noConsole: log
            console.error("PurpleDot: Failed to fetch checkout for ".concat(checkoutId), err);
        }
    });
    useEffect(function() {
        if (checkoutId) {
            SessionStorage.setItem("serverCheckoutId", checkoutId);
            FetchCheckoutTask.run({
                checkoutId: checkoutId
            });
        } else {
            SessionStorage.removeItem("checkoutSession");
            SessionStorage.removeItem("serverCheckoutId");
        }
    }, []);
}
function CartParentPage(param) {
    var instanceId = param.instanceId;
    var sendMessage = function sendMessage(type, data) {
        window.parent.postMessage({
            meta: {
                placementType: "cart-button",
                instanceId: instanceId,
                type: type
            },
            data: data || {}
        }, "*");
    };
    if (!instanceId) {
        throw new Error("No instanceId provided");
    }
    return {
        loaded: function loaded(showButton) {
            sendMessage("loaded", {
                showButton: showButton
            });
        },
        sizeChanged: function sizeChanged(width, height) {
            sendMessage("window-size-changed", {
                width: width,
                height: height
            });
        },
        postVisibilityChanged: function postVisibilityChanged(param) {
            var show = param.show;
            sendMessage("visibility-changed", {
                show: show
            });
        },
        cartButtonEntered: function cartButtonEntered() {
            sendMessage("cart-button-entered");
        },
        cartButtonClicked: function cartButtonClicked() {
            sendMessage("cart-button-clicked");
        }
    };
}
export default expressPage(CartButtonIframe);
